// import React, { useEffect } from 'react';
// import AdminLayout from './Component/AdminLayout';
// import './App.css';

// function App() {

// // useEffect(() => {
// //   document.addEventListener('contextmenu', (e) => {
// //     e.preventDefault();
// //     return false;
// //   });

// //   document.addEventListener("copy", function (e) {
// //         e.preventDefault();
// //     });

// //   document.addEventListener('keydown', (e) => {
// //     // Block F12
// //     if (e.key === 'F12' || e.keyCode === 123) {
// //       e.preventDefault();
// //       return false;
// //     }
    
// //     // Block Ctrl+Shift+I (Inspect)
// //     if (e.ctrlKey && e.shiftKey && e.key === 'I') {
// //       e.preventDefault();
// //       return false;
// //     }
    
// //     // Block Ctrl+Shift+J (Console)
// //     if (e.ctrlKey && e.shiftKey && e.key === 'J') {
// //       e.preventDefault();
// //       return false;
// //     }
    
// //     // Block Ctrl+U (View Source)
// //     if (e.ctrlKey && e.key === 'u') {
// //       e.preventDefault();
// //       return false;
// //     }
    
// //     // Block Ctrl+Shift+C (Inspect Element)
// //     if (e.ctrlKey && e.shiftKey && e.key === 'C') {
// //       e.preventDefault();
// //       return false;
// //     }
// //   });
// // }, []);

//   return (
//     <div className="App">
//       <AdminLayout />
//     </div>
//   );
// }

// export default App;

import React from 'react';
import { Provider } from 'react-redux';
import { store } from './Store/user';
import AppRoutes from './AppRoutes';
import './App.css';

function App() {
  return (
    <div className="App">
      <AppRoutes />
    </div>
  );
}

export default App;